import { useState } from "react";
import { Stack, Tab, Tabs } from "@mui/material";
import { ProcessingTable, UploadTable, EventLogTable } from "..";
import { TestFlowDownloads } from "../TestFlowDownloads";
import type { Flow, FlowOutput, Event } from "../../graphql/types";

const RunDetails = ({ run }: { run: Flow }) => {
  const [currentTab, setCurrentTab] = useState<"Downloads" | "Uploads" | "Events" | "Processing">("Downloads");

  const steps: Array<string> = [];
  if (run.inputs) steps.push("Downloads");
  if (run.outputs) steps.push("Uploads");
  if (run.events) steps.push("Events");
  if (run.processing) steps.push("Processing");

  return (
    <>
      <Tabs value={currentTab} onChange={(_, newValue) => setCurrentTab(newValue)} centered>
        {steps.map((step) => (
          <Tab key={step} value={step} label={step} data-cy={step} />
        ))}
      </Tabs>
      <Stack sx={{ width: "95%" }}>
        {currentTab === "Downloads" && run.inputs ? (
          <TestFlowDownloads inputs={run.inputs} testFlowPhase={run.phase} />
        ) : null}
        {currentTab === "Processing" && run.processing ? <ProcessingTable stats={run.processing} /> : null}
        {currentTab === "Uploads" && run.outputs ? (
          <UploadTable uploads={run.outputs as FlowOutput[]} allowViewDownloads={false} />
        ) : null}
        {currentTab === "Events" && run.events ? <EventLogTable events={run.events as Event[]} /> : null}
      </Stack>
    </>
  );
};

export { RunDetails };
